exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../../../../node_modules/css-loader/index.js!codemirror/lib/codemirror.css"), "");
exports.i(require("-!../../../../../../../../../node_modules/css-loader/index.js!codemirror/theme/blackboard.css"), "");

// module
exports.push([module.id, ".fm-modal-text-edit .modal-body {\n  padding: 0;\n}", ""]);

// exports
